import { createContext } from 'react';

export const themes = {
  light: {
    color: 'primary',
  },
  dark: {
    color: 'default',
  },
};

export const ProspectRegistrationDrawerContext = createContext({
  theme: themes.light,
  toggleTheme: () => {},
});
